import { Component, OnChanges, inject, ChangeDetectionStrategy, input } from '@angular/core';
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ClmPerformanceOutput} from "../../../../model/clm-performance-output";

@Component({
    selector: 'app-clm-cooling-performance-output',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './clm-cooling-performance-output.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-cooling-performance-output.component.css'
})
export class ClmCoolingPerformanceOutputComponent implements OnChanges {
  private readonly userStateService = inject(UserStateService);


  readonly results = input.required<ClmPerformanceOutput>();
  isExpanded = true;
  private sectionKey = ConfigurationSection.COOLING_PERFORMANCE_RESULTS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  hasMessages(): boolean {
    return (this.results()?.messages?.length || 0) > 0;
  }

}
